<template>
	<div>
		<div v-if="isSupplyRoute">
			<div class='tw-flex tw--mx-2'>
				<div class='tw-w-8/12 tw-px-2 tw-flex tw-justify-center'>
					<div class="tw-flex tw--mx-2 tw-items-center">
						<div
							v-for="(supply) in localSupplies"
							class="tw-w-1/4 tw-px-2"
						>
								<supply-card
									:supply='supply'
									:enabled="supply.enabled"
									:selected="supply.id === selectedSupply.id"
									:completed="supply.completed"
									:read-only="supply.readOnly"
									@click="selectSupply"
									@goClick="onNewClicked"
								/>
						</div>
					</div>
				</div>
				<div class='tw-w-4/12 tw-px-2 supply-description-wrapper'>
					<supply-card-detail
						:rotate="rotate"
						:selected-supply="selectedSupply"
					/>
				</div>
			</div>
		</div>
		<div v-else>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import textGraphic from '@/modules/job-evaluation/components/text-graphic';
import supplyCard from '@/modules/job-evaluation/components/supplies/supply-card';
import supplyCardDetail from '@/modules/job-evaluation/components/supplies/supply-card-detail';
import { head, pathOr, pipe, length } from 'ramda';
import { mapState } from 'vuex';
import { parseSupplies } from '@/modules/job-evaluation/utils/supplies/supplies';

const SUPPLIES_ROUTE_NAME = 'job-evaluation-supplies';

export default {
	name: 'page-job-evaluation-supplies',
	data() {
		return {
			rotate: false,
			selectedSupply: {},
			localSupplies: [],
		};
	},
	components: {
		textGraphic,
		supplyCard,
		supplyCardDetail,
	},
	computed: {
		...mapState('jobEvaluation', {
			supplies: pipe(
				pathOr([], ['mainData', 'config', 'stages', 0, 'details']),
				parseSupplies,
			),
		}),
		isSupplyRoute() {
			return this.$route.name === SUPPLIES_ROUTE_NAME;
		},
	},
	watch: {
		supplies: {
			handler(value) {
				if (length(value) > 1) {
					this.localSupplies = value;
					this.selectedSupply = head(this.localSupplies) || {};
				}
			},
			immediate: true,
		},
		$route(newVal) {
			if (newVal && (newVal.name === SUPPLIES_ROUTE_NAME)) {
				this.$store.dispatch('jobEvaluation/loadJobEvaluationConfig');
			}
		},
	},
	methods: {
		selectSupply(supply) {
			if (this.selectedSupply.id === supply.id) return;
			this.selectedSupply = supply;
			this.rotate = !this.rotate;
		},
		onNewClicked(selectedSupply) {
			this.goTo(selectedSupply.goTo);
		},
	},
};
</script>
<style lang="scss" scoped>
.supply-description-wrapper {
	min-height: 600px;
}
</style>





// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/supplies/page-job-evaluation-supplies.vue